import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

/**
 * `master/notification/subscription/preview` — dry-run resolusi penerima, GET doang, nggak nulis apa-apa.
 *
 * @typedef {Object} PreviewRecipient
 * @property {'USER'|'CONTACT'|'MEMBERS'} audienceType
 * @property {number|string} id ntcnId angka buat CONTACT, email buat USER, kosong buat MEMBERS
 * @property {'inapp'|'email'|'push'|'whatsapp'|'webhook'} channel
 * @property {number} ntsbId baris subscription sumbernya
 *
 * @typedef {Object} PreviewSkipped
 * @property {'USER'|'CONTACT'|'MEMBERS'} audienceType
 * @property {number|string} id bentuknya sama kayak PreviewRecipient
 * @property {string} channel
 * @property {number} ntsbId
 * @property {string} reason apa adanya dari backend, daftarnya belum tertutup
 */

export default {
  /**
   * GET `master/notification/subscription/preview`
   *
   * @param {Object} params hasil `previewParams`: `ntopCode` (wajib, code bukan id),
   *   `compId?`, `massId?`, `phase?`, `severity?`
   * @returns {Promise<import('axios').AxiosResponse<{
   *   item: Object, recipients: PreviewRecipient[], skipped: PreviewSkipped[],
   *   status: import('@/services/_AxiosInstance').ApiStatus,
   * }>>} response axios mentah — HTTP 200 tetap bisa bawa `status.errorCode` 404
   *   (topic code gak dikenal) atau 412 (asset di luar akses)
   */
  getPreview(params) {
    return axiosInstance.get('/master/notification/subscription/preview', {
      params,
      cancelToken: getNewCancelToken(),
    });
  },
};
